/**
 * Milliseconds
 */
export const DURATION_1_SECS_MILLISECONDS = 1000;
export const DURATION_3_SECS_MILLISECONDS = 3 * DURATION_1_SECS_MILLISECONDS;
export const DURATION_5_SECS_MILLISECONDS = 5 * DURATION_1_SECS_MILLISECONDS;
export const DURATION_90_SECS_MILLISECONDS = 90 * DURATION_1_SECS_MILLISECONDS;
export const DURATION_1_MIN_MILLISECONDS = 60 * DURATION_1_SECS_MILLISECONDS;
export const DURATION_4_MIN_MILLISECONDS = 4 * DURATION_1_MIN_MILLISECONDS;
export const DURATION_5_MIN_MILLISECONDS = 5 * DURATION_1_MIN_MILLISECONDS;
export const DURATION_13_MIN_MILLISECONDS = 13 * DURATION_1_MIN_MILLISECONDS;
export const DURATION_1_HR_MILLISECONDS = 60 * DURATION_1_MIN_MILLISECONDS;

/**
 * Seconds
 */
export const DURATION_10_SECONDS = 10;
export const DURATION_20_SECONDS = 20;
export const DURATION_90_SECONDS = 90;
export const DURATION_1_MIN_SECONDS = 1 * 60;
export const DURATION_5_MIN_SECONDS = DURATION_1_MIN_SECONDS * 5;
export const DURATION_1_HR_SECONDS = 60 * DURATION_1_MIN_SECONDS;
export const DURATION_2_HR_SECONDS = 24 * DURATION_5_MIN_SECONDS;

/** countdown timer for OTP */
export const RESEND_OTP_COUNTDOWN_TIME = 120;
